// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"151":"60f685f5","483":"d61df159","512":"9d849fa8","750":"36927873","791":"5c1538d1"}[chunkId] + ".css";
};